
.QueryMultiFooter {
  position: relative;
  margin-bottom: 5px;
}

.FetchingOpacity {
  opacity: 0.5;
}
